import React from "react";
import { pricing } from "../data/landing";
export function DollarPriceNotice() {
  return <div className="cd" data-id="element-17" data-mp="3gwchpj3p4odv">
      <div className="cdh" data-id="element-18" data-mp="3gujb23t3245v">
        <i data-id="element-19" data-mp="3gxxdtd5nsfdu">⚡</i>
        <span data-id="element-20" data-mp="3gxnprv46cias">Este preço está em dólares</span>
      </div>
      <div className="cdt" data-id="element-21" data-mp="3265ay0n1wtt0">
        <div className="tc" data-id="element-22" data-mp="324u6rzpp1k1d">
          <span className="tcv" data-id="element-23" data-mp="375rko03o7rx2">{pricing.price}</span>
          <small data-id="element-24" data-mp="3746u0lkh8t4h">HOJE VOCÊ PAGA</small>
        </div>
        <div className="sep" data-id="element-25" data-mp="2t5qmisesiyla">→</div>
        <div className="tc tcx" data-id="element-26" data-mp="2t4p05rsbqpo9">
          <span className="tcv tco" data-id="element-27" data-mp="2t8miib72vd73">{pricing.originalPrice}</span>
          <small data-id="element-28" data-mp="2x9etp9zifs60">PREÇO NORMAL</small>
        </div>
      </div>
      <p className="cdp" data-id="element-29" data-mp="2j8lwghhtqiz7">
        A coleção está cotada em <b data-id="element-30" data-mp="2ja6tcdrm2e08">dólares</b> e o pagamento é convertido para a sua moeda no câmbio do dia. Se o
        dólar subir, amanhã fica mais caro. <b data-id="element-31" data-mp="hgpm3b7e7f60">Comprando hoje, você garante o preço de hoje.</b>
      </p>
    </div>;
}